import React from 'react'
import ItemPerformances from './ItemPerformances'
import getData from '../functions/getData'
import { FRONT, TRANSLATION } from '../constants/state'
import { compose } from 'redux';
import { connect } from 'react-redux';
import toJS from '../hoc/toJS';

const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT),
    translation: getData(state, TRANSLATION)
})

const ItemPerformancesContainer = ({
    movieId, 
    currentCinemaType, 
    filterType, 
    stripeAppearance, 
    filterValue, 
    itemData, 
    performances, 
    clusterCinemaOption, 
    clusterCinemaActive, 
    activeCinema, 
    overviewFilterIgnoreOnPerformances,
    additionalClass, 
    theme,
    dayFilters,
    queryStringValues,
    translation, 
    onClick, 
    scrollToPosition, 
    isOverview, 
    isMobile, 
    showMobileMovieTimes, 
    onOpenPerformancePage, 
    currentBrowserWidth,
    cinemaDataFront
}) => {

    const {
        ignore_attributes_for_performance_filter
    } = cinemaDataFront

    const {technologyAttributes} = itemData

    const containsVorschau = _.find(technologyAttributes, attribute => {
        return _.contains(ignore_attributes_for_performance_filter, attribute.id) 
    })


    return <ItemPerformances
        movieId={movieId} 
        currentCinemaType={currentCinemaType} 
        filterType={filterType} 
        stripeAppearance={stripeAppearance} 
        filterValue={filterValue} 
        itemData={itemData} 
        performances={performances} 
        clusterCinemaOption={clusterCinemaOption} 
        clusterCinemaActive={clusterCinemaActive} 
        activeCinema={activeCinema} 
        overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
        additionalClass={additionalClass} 
        theme={theme}
        dayFilters={dayFilters}
        queryStringValues={queryStringValues}
        containsVorschau={containsVorschau} 
        translation={translation} 
        onClick={onClick} 
        scrollToPosition={scrollToPosition} 
        isOverview={isOverview} 
        isMobile={isMobile} 
        showMobileMovieTimes={showMobileMovieTimes} 
        onOpenPerformancePage={onOpenPerformancePage} 
        currentBrowserWidth={currentBrowserWidth}
    />
}


export default compose(
    connect(mapStateToProps, null),
    toJS()
)(ItemPerformancesContainer)